/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var tmpl = __webpack_require__(1);
var TG_BOTTOMFLOAT_KEY = 'TG_BOTTOMFLOAT_KEY';
adv.AdBase.extend('AdMobileMadGlobalBottomFloat', {
  init: function init(options) {
    this.base(options);
    this.emit(adv.ENUM.EVENTS.inited);
  },
  setup: function setup(data) {
    this.data = data;
    this.emit(adv.ENUM.EVENTS.setuped);
  },
  play: function play() {
    var _self = this;
    var ignoreIndex = false;
    if (location.hostname == 'm.17173.com' && location.pathname == '/') {
      ignoreIndex = true;
    }

    if (!ignoreIndex && !adv.storage.get(TG_BOTTOMFLOAT_KEY)) {
      var advEl = $(this.options.selector);
      advEl.append(adv.razor(tmpl, this.data));

      var $container = adv.$('.tg-footer-fix');

      $container.find('img').on('load', function () {
        if ($container.length > 0) {
          _self._show($container);
        }
      });

      $container.find('.tg-footer-fix-close').on('click', function () {
        _self._hide($container);
        var now = new Date();
        var todayEnd = new Date(now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate() + ' 23:59:59').getTime();
        adv.storage.set(TG_BOTTOMFLOAT_KEY, 'ignoreThis', todayEnd - Date.now(), '17173.com', '/');
      });

      this.emit(adv.ENUM.EVENTS.played);
    }
  },
  _show: function _show(el) {
    el.css('display', 'block');
  },
  _hide: function _hide(el) {
    el.css('display', 'none');
  }
});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = "<style>\n.tg-footer-fix {\n    overflow: hidden; position: fixed; z-index: 680; bottom: 0; left:0; width:100%; text-align: center; background-color:rgba(0,0,0,.5);\n}\n.tg-footer-fix .tg-footer-fix-in { \n    display: inline-block; position: relative; width: 84%; height: 40px; padding-right:40px; box-sizing:border-box; vertical-align: middle;\n}\n.tg-footer-fix img {\n    width:100%; max-height: 100%; border:0;\n}\n.tg-footer-fix .tg-footer-fix-close {\n    position: absolute; top:0; right:0; width:40px; height: 40px; font: normal 40px/40px \"sans-serif\"; color:#fff; text-decoration: none; background: #555;\n}\n.madglobalbottomfloat-hide {\n    display: none;\n}\n</style>\n<div class=\"tg-footer-fix @advid\" style=\"display:none;\">\n    <div class=\"tg-footer-fix-in\">\n        <a href=\"@link\"><img src=\"@image\" alt=\"\"></a>\n        <a href=\"javascript:;\" class=\"tg-footer-fix-close\">×</a>\n    </div>\n</div>"

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// v1-0/production.js